module.exports = __webpack_public_path__ + "static/fonts/iconfont.7dded6f.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/csslib/iconfont/iconfont.ttf?t=1639703065688
// module id = GKAr
// module chunks = 193